<div class="top-menu">
  <ul *ngIf="menu">
    <ng-container *ngFor="let item of menu.items">
      <app-menu-item [item]="item" [customClass]="'top-menu-item'"></app-menu-item>
    </ng-container>
  </ul>
</div>
